import { NgModule } from '@angular/core';
import { ConnectionService } from './connection-service.service';

@NgModule({
  imports: [
  ],
  providers:[ConnectionService]
})
export class ConnectionServiceModule { }
